import { LocationNumbersService } from "../../../services"

const fetchCampaignStatus = async function(_, payload) {

  try {
    const { data } = await LocationNumbersService.getA2PBrandStatus(
      payload
    )

    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export default fetchCampaignStatus
